import Small from 'UIComponents/elements/Small';
import UIMediaObject from 'UIComponents/layout/UIMediaObject';
import FormattedDate from './FormattedDate';
import ApprovalUserAvatar from '../user/ApprovalUserAvatar';
import ApprovalUserFormattedName from '../ApprovalUserFormattedName';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalNote(props) {
  const {
    approvalUser,
    note,
    timestamp
  } = props;
  return /*#__PURE__*/_jsx(UIMediaObject, {
    spacing: "none",
    itemLeft: /*#__PURE__*/_jsx(ApprovalUserAvatar, {
      approvalUser: approvalUser
    }),
    children: /*#__PURE__*/_jsxs("div", {
      className: "display-flex flex-column m-left-5",
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("strong", {
          children: /*#__PURE__*/_jsx(ApprovalUserFormattedName, {
            approvalUser: approvalUser
          })
        }), timestamp && /*#__PURE__*/_jsx(Small, {
          className: "m-left-2",
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedDate, {
            date: timestamp
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          overflowWrap: 'anywhere',
          hyphens: 'auto'
        },
        children: note
      })]
    })
  });
}
export default ApprovalNote;